import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import IconCaret from '../../files/caret.svg';
import IconGlobe from '../../files/globe.svg';
import IconAusMap from '../../files/australia-map.svg';


const mapHeaderLink = ({ label, url }) => (
  <li key={url} className="header-links__item">
    <a href={url} className="header-links__link">
      {label}
    </a>
  </li>
);
const mapListLink = ({ label, url, lang }) => (
  <li key={url} className="utility-menu__list-item">
    <a href={url} lang={lang} className="utility-menu__list-link">
      {label}
    </a>
  </li>
);

const UtilityMenu = ({ headerLinks, langLinks, regionLinks }) => {
  const [isLangListExpanded, setIsLangListExpanded] = useState(false);
  const [isRegionListExpanded, setIsRegionListExpanded] = useState(false);

  const langBtnClasses = classnames('utility-menu__btn', {
    active: isLangListExpanded,
  });

  const regionBtnClasses = classnames('utility-menu__btn', {
    active: isRegionListExpanded,
  });

  const langListClasses = classnames(
    'utility-menu__list language-links__list',
    {
      active: isLangListExpanded,
    }
  );

  const regionListClasses = classnames(
    'utility-menu__list region-links__list',
    {
      active: isRegionListExpanded,
    }
  );

  const toggleLangList = (evt) => {
    evt.preventDefault();
    setIsLangListExpanded(!isLangListExpanded);
  };

  const openLangList = (evt) => {
    evt.preventDefault();
    setIsLangListExpanded(true);
    setIsRegionListExpanded(false);
  };

  const toggleRegionList = (evt) => {
    evt.preventDefault();
    setIsRegionListExpanded(!isRegionListExpanded);
  };

  const openRegionList = (evt) => {
    evt.preventDefault();
    setIsRegionListExpanded(true);
    setIsLangListExpanded(false);
  };

  const closeLists = (evt) => {
    evt.preventDefault();
    setIsLangListExpanded(false);
    setIsRegionListExpanded(false);
  };

  const handleKeyDownUtilityMenu = (evt) => {
    if (evt.key === 'Escape') {
      closeLists(evt);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDownUtilityMenu);
    // Remove event listener on cleanup
    return () => {
      document.removeEventListener('keydown', handleKeyDownUtilityMenu);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return (
    <div className="utility-menu" onMouseLeave={closeLists}>
      <ul className="header-links" onMouseEnter={closeLists}>
        {headerLinks.map(mapHeaderLink)}
      </ul>
      <div className="language-links" onMouseEnter={openLangList}>
        <button
          className={langBtnClasses}
          onClick={toggleLangList}
          onTouchEnd={toggleLangList}
        >
          <div className="utility-menu__btn-wrapper">
            <IconGlobe focusable={false} className="utility-menu__icon" width="20" height="20"/>
            <span className="utility-menu__btn-text">Language</span>
          </div>
          <IconCaret focusable={false} className="utility-menu__btn-icon" />
        </button>
        <ul className={langListClasses}>{langLinks.map(mapListLink)}</ul>
      </div>
      <div className="region-links" onMouseEnter={openRegionList}>
        <button
          className={regionBtnClasses}
          onClick={toggleRegionList}
          onTouchEnd={toggleRegionList}
        >
          <div className="utility-menu__btn-wrapper">
            <IconAusMap focusable={false} className="utility-menu__icon" width="20" height="20"/>
            <span className="utility-menu__btn-text">States & territories</span>
          </div>
          <IconCaret focusable={false} className="utility-menu__btn-icon" />
        </button>
        <ul className={regionListClasses}>{regionLinks.map(mapListLink)}</ul>
      </div>
    </div>
  );
};

export default UtilityMenu;
